var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDragDrop = function SvgDragDrop(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.42969,
    y: 2.42969,
    width: 46.4041,
    height: 9.57545,
    fill: "#0258FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30445 6.69531C9.40764 6.69531 9.50852 6.72591 9.59432 6.78324C9.68012 6.84057 9.74699 6.92206 9.78648 7.01739C9.82597 7.11273 9.8363 7.21763 9.81617 7.31884C9.79604 7.42005 9.74635 7.51301 9.67338 7.58598C9.60041 7.65894 9.50745 7.70863 9.40624 7.72877C9.30503 7.7489 9.20013 7.73856 9.10479 7.69908C9.00946 7.65959 8.92797 7.59271 8.87064 7.50691C8.81331 7.42111 8.78271 7.32024 8.78271 7.21705C8.78271 7.07868 8.83768 6.94597 8.93553 6.84813C9.03337 6.75028 9.16608 6.69531 9.30445 6.69531",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4732 6.69531C15.5763 6.69531 15.6772 6.72591 15.763 6.78324C15.8488 6.84057 15.9157 6.92206 15.9552 7.01739C15.9947 7.11273 16.005 7.21763 15.9849 7.31884C15.9647 7.42005 15.915 7.51301 15.8421 7.58598C15.7691 7.65894 15.6761 7.70863 15.5749 7.72877C15.4737 7.7489 15.3688 7.73856 15.2735 7.69908C15.1782 7.65959 15.0967 7.59271 15.0393 7.50691C14.982 7.42111 14.9514 7.32024 14.9514 7.21705C14.9514 7.07868 15.0064 6.94597 15.1042 6.84813C15.2021 6.75028 15.3348 6.69531 15.4732 6.69531",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3657 6.69531C21.4689 6.69531 21.5698 6.72591 21.6556 6.78324C21.7414 6.84057 21.8083 6.92206 21.8478 7.01739C21.8872 7.11273 21.8976 7.21763 21.8774 7.31884C21.8573 7.42005 21.8076 7.51301 21.7347 7.58598C21.6617 7.65894 21.5687 7.70863 21.4675 7.72877C21.3663 7.7489 21.2614 7.73856 21.1661 7.69908C21.0707 7.65959 20.9893 7.59271 20.9319 7.50691C20.8746 7.42111 20.844 7.32024 20.844 7.21705C20.844 7.07868 20.899 6.94597 20.9968 6.84813C21.0947 6.75028 21.2274 6.69531 21.3657 6.69531",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8261 2H6.17391C3.86872 2 2 3.86872 2 6.17391V45.8261C2 48.1313 3.86872 50 6.17391 50H45.8261C48.1313 50 50 48.1313 50 45.8261V6.17391C50 3.86872 48.1313 2 45.8261 2Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.4346H50",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4784 18.6963H9.30446C8.72817 18.6963 8.26099 19.1635 8.26099 19.7398V42.6963C8.26099 43.2726 8.72817 43.7398 9.30446 43.7398H13.4784C14.0547 43.7398 14.5219 43.2726 14.5219 42.6963V19.7398C14.5219 19.1635 14.0547 18.6963 13.4784 18.6963Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26099 24.957H14.5219",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26099 31.2178H14.5219",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26099 37.4785H14.5219",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2175 34.3482C31.2175 34.0714 31.3275 33.806 31.5232 33.6103C31.7188 33.4146 31.9843 33.3047 32.261 33.3047H34.348L36.8252 35.3916H42.6958C42.9725 35.3916 43.238 35.5016 43.4336 35.6973C43.6293 35.893 43.7393 36.1584 43.7393 36.4351V42.696C43.7393 42.9727 43.6293 43.2382 43.4336 43.4338C43.238 43.6295 42.9725 43.7395 42.6958 43.7395H32.261C31.9843 43.7395 31.7188 43.6295 31.5232 43.4338C31.3275 43.2382 31.2175 42.9727 31.2175 42.696V34.3482Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7085 30.3203L38.7826 21.793",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4346 19.7721C42.6346 20.1333 42.723 20.5457 42.6886 20.9572C42.6542 21.3686 42.4985 21.7606 42.2413 22.0836C41.984 22.4065 41.6367 22.6459 41.2434 22.7714C40.85 22.897 40.4283 22.903 40.0315 22.7887C39.6347 22.6745 39.2808 22.4451 39.0144 22.1297C38.748 21.8142 38.5812 21.4268 38.535 21.0165C38.4889 20.6062 38.5655 20.1914 38.7552 19.8246C38.9448 19.4579 39.239 19.1556 39.6005 18.9561C40.0846 18.6889 40.655 18.6248 41.1864 18.7778C41.7177 18.9308 42.1667 19.2884 42.4346 19.7721Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7234 33.0957C22.351 33.2747 21.9338 33.3392 21.5247 33.281C21.1156 33.2228 20.733 33.0444 20.4254 32.7685C20.1178 32.4926 19.899 32.1316 19.7968 31.7312C19.6946 31.3308 19.7135 30.9091 19.8512 30.5195C19.9889 30.1299 20.2391 29.79 20.5702 29.5427C20.9013 29.2955 21.2983 29.1521 21.711 29.1307C22.1236 29.1094 22.5333 29.211 22.8882 29.4227C23.243 29.6344 23.5271 29.9467 23.7042 30.32C23.9408 30.8184 23.9704 31.3901 23.7866 31.9102C23.6028 32.4304 23.2205 32.8566 22.7234 33.0957Z",
    stroke: "#0258FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDragDrop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/drag-drop.7a421883.svg";
export { ForwardRef as ReactComponent };